import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AllhomesCollapsibleDescription from '@domain-group/fe-co-allhomes-collapsible-description';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import AgentStats from '@domain-group/fe-co-allhomes-agent-stats';
var Info = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-agency-profile/static/info_951c19ac.png";
import * as styles from './agency-body.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgencyBody = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var onClickDescription = event => {
    if (event === 'show') {
      sendEvent('show-more');
    }
  };
  var hasValue = function hasValue() {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    return values.some(val => val && val !== '0' && val !== '-');
  };
  return ___EmotionJSX(Fragment, null, hasValue(props.stats.sold, props.stats.forSale, props.stats.averageDays, props.stats.rented, props.stats.forRent, props.stats.soldDevelopments, props.stats.developments, props.stats.soldDevelopmentsSecondary, props.stats.rentedSecondary, props.stats.soldSecondary) && ___EmotionJSX("div", {
    css: styles.stats
  }, ___EmotionJSX("div", {
    css: styles.info
  }, ___EmotionJSX("img", {
    src: Info,
    alt: "",
    css: styles.infoImage
  }), ___EmotionJSX("span", {
    css: styles.message
  }, "Listing counts are for properties advertised on Allhomes in last 12 months")), ___EmotionJSX("div", null, ___EmotionJSX(AgentStats, {
    soldAll: props.stats.sold,
    saleAll: props.stats.forSale,
    averageDaysAll: props.stats.averageDays,
    rentedAll: props.stats.rented,
    rentAll: props.stats.forRent,
    soldDevelopmentsAll: props.stats.soldDevelopments,
    developmentsAll: props.stats.developments,
    soldDevelopmentsSecondary: props.stats.soldDevelopmentsSecondary,
    rentedSecondary: props.stats.rentedSecondary,
    soldSecondary: props.stats.soldSecondary
  }))), ___EmotionJSX("div", {
    css: styles.body,
    "data-testid": "agency-description"
  }, props.description && ___EmotionJSX(AllhomesCollapsibleDescription, {
    description: props.description,
    maxPreviewHeight: props.maxPreviewHeight,
    onClick: onClickDescription
  })));
};
AllhomesAgencyBody.propTypes = {
  description: PropTypes.string,
  maxPreviewHeight: PropTypes.number,
  stats: PropTypes.shape({
    sold: PropTypes.string,
    forSale: PropTypes.string,
    averageDays: PropTypes.string,
    forRent: PropTypes.string,
    rented: PropTypes.string,
    soldDevelopments: PropTypes.string,
    soldDevelopmentsSecondary: PropTypes.string,
    developments: PropTypes.string,
    rentedSecondary: PropTypes.string,
    soldSecondary: PropTypes.string
  }).isRequired
};
AllhomesAgencyBody.defaultProps = {
  maxPreviewHeight: 220,
  description: ''
};
export default AllhomesAgencyBody;